import en from './en'
import es from './es'

export const supportedLanguages = ['en', 'es']
export const defaultLanguage = 'es'
export default { en, es }
